import React, { FC, useCallback, useEffect, useState, useContext } from 'react';
import { get, post } from "../fetchers/fetchers";

import { useParams } from "react-router";

import {
    IconButton,
    Table,
    TableCell,
    TableHead, Typography,

} from "@material-ui/core";
import {
    IAdequacy,
    IControlMeasure,
    IControlMeasureAdequacy, IControlMeasureCost, IFailureModeAssessment,
    IProjectFailureMode

} from "../types/types";

import ControlMeasureAdequacy from "./control_measure_adequacy";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

import { TasksContext, TasksDispatchContext, TasksProvider, useTask } from '../stateManagement/context';


import { getControlMeasureAdequacy } from "../stateManagement/data";

import { APPLICATION } from "../env";
import { API_URL } from "../env";


interface IControlMeasureAdequaciesProps {
    existing: boolean
}

interface IRouteParams {
    id: string
}



const ControlMeasureAdequacies: FC<IControlMeasureAdequaciesProps> = ({ existing }) => {

    let dispatch = useContext(TasksDispatchContext)
    let tasks = useTask()


    const [isLoaded, setIsLoaded] = useState<boolean>(true);
    const [controlMeasureAdequacy, setControlMeasureAdequacy] = useState<IControlMeasureAdequacy[]>([]);
    const [failureModes, setFailureModes] = useState<IProjectFailureMode[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [adequacies, setAdequacies] = useState<IAdequacy[]>([]);
    const [reloadAdequacies, setReloadAdequacies] = useState<boolean>(false);
    const [failureModeAssessments, setFailureModeAssessments] = useState<IFailureModeAssessment[]>([]);

    useEffect(() => {

        if (tasks.loaded) {

            setFailureModes(tasks.failureModes)
            setFailureModeAssessments(tasks.failureModeAssessments)
            setAdequacies(tasks.adequacies)
            setControlMeasureAdequacy(tasks.controlMeasureAdequacy)
        }

    })



    const params = useParams<IRouteParams>()



    const getCMeasureAdequacy = (cm: IProjectFailureMode): IControlMeasureAdequacy => {

        if (!cm.id)
            throw new Error("IProjectFailureMode.id needs to be set")
        let ca = controlMeasureAdequacy.find(ca => ca.project_failure_mode_id === cm.id)

        if (ca) {
            return ca
        }
        ca = {
            project_failure_mode_id: cm.id

        }
        return ca
    }

    const postControlMeasureAdequacy = async (controlMeasureAdequacy: IControlMeasureAdequacy) => {
        delete controlMeasureAdequacy.id
        delete controlMeasureAdequacy.additional_adequacy
        delete controlMeasureAdequacy.existing_adequacy
        delete controlMeasureAdequacy.improvement_adequacy

        let d = await post<IControlMeasureAdequacy>(API_URL + "control_measures/" + params.id.toString() + "/control_measure_adequacy", controlMeasureAdequacy);
        let e = await getControlMeasureAdequacy(params.id, dispatch)
    }

    const updateControlMeasuresAdequacy = useCallback((controlMeasureAdequacy: IControlMeasureAdequacy) => {

        postControlMeasureAdequacy(controlMeasureAdequacy).then(() => {
            setReloadAdequacies(true);
        })
    }, [setControlMeasureAdequacy, setIsLoaded]);

    return (<>
        <Table>
            <TableHead>
                <TableCell></TableCell>

                {APPLICATION === "SFAIRP" && <TableCell>Critical Failure Mode</TableCell> }
                {APPLICATION === "ALARP" && <TableCell>Priority Failure Mode</TableCell> }
                <TableCell>Existing Control Measure</TableCell>
                <TableCell>Additional Control Measure</TableCell>
                <TableCell>Improvement Opportunity</TableCell>
                <TableCell width={"40%"}>Assessment</TableCell>
                <TableCell>Comments</TableCell>
            </TableHead>

            {isLoaded && failureModes.map((f) => {
                if (f.failure_mode?.is_active === false) { return <></> }
                let fma = failureModeAssessments.find(fma => fma.project_failure_mode_id === f.id)
                if (!fma) { return <></> }
                if (fma.consider) {
                    return <ControlMeasureAdequacy
                        control_measure_adequacy={getCMeasureAdequacy(f)}
                        project_failure_mode={f}
                        updateControlMeasuresAdequacy={updateControlMeasuresAdequacy}
                        adequacies={adequacies} />

                } else {
                    return <></>
                }


            })}

        </Table>
        <div>
            <Typography><small>Note only included group failure modes are shown</small></Typography>
        </div>
    </>


    );
}

export default ControlMeasureAdequacies;
